module.exports = __webpack_public_path__ + "static/media/right_color.da06b054.png";